import { render, staticRenderFns } from "./buyCardList.vue?vue&type=template&id=524f3b3b&"
import script from "./buyCardList.vue?vue&type=script&lang=js&"
export * from "./buyCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports